// Angular
import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
// RxJS
import { Observable } from 'rxjs';
// NGRX
import { select, Store } from '@ngrx/store';
// State
import { AppState } from '../../../../../core/reducers';
import { currentUser, Logout, User, authRole, AuthService } from '../../../../../core/auth';
import { tap, take } from 'rxjs/operators';
import { MatDialog } from '@angular/material';
import { LogoutDialogComponent } from '../../../content/crud';
import { ENUM } from '../../../../../core/enum/enum';
import * as moment from 'moment';
@Component({
	selector: 'kt-user-profile2',
	templateUrl: './user-profile2.component.html',
	styleUrls: ['./user-profile2.component.scss']
})
export class UserProfile2Component implements OnInit {
	// Public properties
// Public properties
user$: Observable<User>;
userRole;
Enum = ENUM;
shift = null;
moment = moment;
@Input() avatar: boolean = true;
@Input() greeting: boolean = true;
@Input() badge: boolean;
@Input() icon: boolean;
/**
 * Component constructor
 *
 * @param store: Store<AppState>
 */
constructor(private store: Store<AppState>,
	private dialog: MatDialog,
	private cdr: ChangeDetectorRef,
	private authService:AuthService) {
}

/**
 * @ Lifecycle sequences => https://angular.io/guide/lifecycle-hooks
 */

/**
 * On init
 */
ngOnInit(): void {
	this.user$ = this.store.pipe(select(currentUser));
	this.store.select(authRole).pipe(tap(role => {
	   this.userRole = +role;
	})).subscribe();
}

/**
 * Log out
 */
logout() {
 this.store.select(authRole).pipe(take(1)).subscribe((role) => {
		if(role == ENUM.roles.CASHIER){
			let dialogRef = this.dialog.open(LogoutDialogComponent,{data:{}});
			dialogRef.afterClosed().subscribe((val) => {
			   if(!!val){
				 this.authService.signoutCashier(val.amount).subscribe((res) => {
					this.shift = res;
					this.cdr.detectChanges();
					setTimeout(() => {
						this.doPrint();
						this.store.dispatch(new Logout());
					}, 500);				 
				})
			   }
			});
		}else{
			this.authService.signout().subscribe((res) => {
				this.store.dispatch(new Logout());
			})
		}
	})
}

doPrint(){
	let printContents, popupWin;
	printContents = document.getElementById('print-section-shift').innerHTML;
	popupWin = window.open('', '_blank', 'top=0,left=0,height=100%,width=auto');
	popupWin.document.open();
	popupWin.document.write(`
	  <html>
		<head>
		  <title>Print tab</title>
		  <style>
		  *{
			  direction:rtl;
		  }
		  @page{
			margin-left:5mm;
			margin-right:5mm;
			size: auto auto;
		  }
		  body  
		  { 
			  /* this affects the margin on the content before sending to printer */ 
			  margin: 0px;  
			  direction: rtl;
		  } 
		  </style>
		</head>
	<body onload="window.print();">${printContents}</body>
	  </html>`
	);
	popupWin.document.close();
  }

}
